export default [
  {
    component: () => import('./Entrepreneur.vue'),
    children: [
      {
        name: 'EnvironmentalLicenseRequest',
        path: '/environmental-license/request',
        component: () => import('./content/EnvironmentalLicenseRequest.vue'),
        meta: {
          title: 'Novo requerimento de licença ambiental',
        },
      },
      {
        name: 'Enterprises',
        path: '/enterprises',
        component: () => import('./content/Enterprises.vue'),
        meta: {
          title: 'Meus empreendimentos',
        },
      },
    ],
  },
];
